import type { Card } from '@mtg/shared';

/**
 * A card image from Scryfall, shown whole: Scryfall's terms ask that the
 * artist and copyright lines are never cropped and the image isn't altered.
 */
export function CardImage({ card, size = 'normal', back = false }: { card: Card; size?: 'small' | 'normal' | 'large'; back?: boolean }) {
  const src = back ? card.imageBack : size === 'small' ? card.imageSmall : size === 'large' ? card.imageLarge : card.imageNormal;
  if (!src) return <div className="card-img placeholder">{card.name}</div>;
  return <img className="card-img" src={src} alt={card.name} loading="lazy" width={488} height={680} />;
}
